module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.hasBeenDeleted(_vm.post)) ? _c('article', {
    staticClass: "forum-post"
  }, [_c('ForumAvatar', {
    attrs: {
      "src": _vm.getAuthorAvatar(_vm.post.author)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "post-body"
  }, [_c('div', {
    staticClass: "post-meta"
  }, [_c('div', {
    staticClass: "post-context"
  }, [_c('router-link', {
    staticClass: "author-name",
    attrs: {
      "to": _vm.getAuthorUrl(_vm.post.author)
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.getAuthorName(_vm.post.author)) + "\n                ")]), _vm._v(" "), (_vm.post.author && _vm.post.author.roles.length > 0) ? _c('span', {
    staticClass: "author-role"
  }, [_c('img', {
    attrs: {
      "src": _vm.getAuthorRoleIcon(_vm.post.author),
      "title": _vm.getAuthorRole(_vm.post.author)
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getAuthorRole(_vm.post.author)))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "post-date"
  }, [(_vm.hasBeenEdited(_vm.post)) ? _c('span', {
    staticClass: "edit-status",
    attrs: {
      "title": _vm.editStatus(_vm.post)
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "title": _vm.postStatus(_vm.post)
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.prettyPostDate(_vm.post)) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "post-content"
  }, [(_vm.sourcePost) ? _c('ForumPostBlock', [_c('template', {
    attrs: {
      "slot": "context"
    },
    slot: "context"
  }, [_c('i', {
    staticClass: "intro-icon fa fa-reply"
  }), _vm._v(" "), _c('span', {
    staticClass: "intro-text"
  }, [_vm._v("Reply to")]), _vm._v(" "), _c('div', {
    staticClass: "avatar-small"
  }, [_c('ForumAvatar', {
    attrs: {
      "src": _vm.getAuthorAvatar(_vm.sourcePost.author)
    }
  })], 1), _vm._v(" "), (_vm.sourcePost.author) ? _c('router-link', {
    staticClass: "author-name",
    attrs: {
      "to": _vm.getAuthorUrl(_vm.sourcePost.author)
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.getAuthorName(_vm.sourcePost.author)) + "\n                    ")]) : _c('span', {
    staticClass: "author-name"
  }, [_vm._v("\n                        " + _vm._s(_vm.getAuthorName(_vm.sourcePost.author)) + "\n                    ")])], 1), _vm._v(" "), _c('template', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('button', {
    attrs: {
      "title": "Go to the source post"
    },
    on: {
      "click": function($event) {
        _vm.goToSourcePost()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-up"
  })])])], 2) : _vm._e(), _vm._v(" "), (!_vm.hasBeenDeleted(_vm.post)) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing),
      expression: "!isEditing"
    }],
    ref: "content",
    staticClass: "post-content-html",
    domProps: {
      "innerHTML": _vm._s(_vm.post.content)
    },
    on: {
      "click": _vm.onContentClick
    }
  }) : _c('div', {
    staticClass: "post-content-html"
  }, [_c('em', [_vm._v("Post has been deleted.")])]), _vm._v(" "), (_vm.isEditing) ? _c('HtmlEditor', {
    ref: "editor",
    staticClass: "html-editor",
    attrs: {
      "contentClass": "post-content-html",
      "allowEmoji": true,
      "stickyToolbar": true,
      "tagMap": {
        h1: 'h3',
        h2: 'h4'
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.answerPost) ? _c('ForumPostBlock', {
    attrs: {
      "theme": "success"
    }
  }, [_c('template', {
    attrs: {
      "slot": "context"
    },
    slot: "context"
  }, [_c('i', {
    staticClass: "intro-icon fa fa-check-square-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "intro-text"
  }, [_vm._v("Answered by")]), _vm._v(" "), _c('div', {
    staticClass: "avatar-small"
  }, [_c('ForumAvatar', {
    attrs: {
      "src": _vm.getAuthorAvatar(_vm.answerPost.author)
    }
  })], 1), _vm._v(" "), (_vm.answerPost.author) ? _c('router-link', {
    staticClass: "author-name",
    attrs: {
      "to": _vm.getAuthorUrl(_vm.answerPost.author)
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.getAuthorName(_vm.answerPost.author)) + "\n                    ")]) : _c('span', {
    staticClass: "author-name"
  }, [_vm._v("\n                        " + _vm._s(_vm.getAuthorName(_vm.answerPost.author)) + "\n                    ")])], 1), _vm._v(" "), _c('template', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('button', {
    attrs: {
      "title": "Go to the answer post"
    },
    on: {
      "click": function($event) {
        _vm.goToAnswerPost()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-down"
  })])])], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "post-actions"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing && !_vm.isDeleting),
      expression: "!isEditing && !isDeleting"
    }]
  }, [(_vm.canSolve) ? _c('button', {
    class: {
      'accent-answer': _vm.isAnswer
    },
    attrs: {
      "title": _vm.isAnswer ? 'Unmark as answer' : 'Mark as answer'
    },
    on: {
      "click": function($event) {
        _vm.toggleAnswer()
      }
    }
  }, [(_vm.isAnswer) ? _c('i', {
    staticClass: "fa fa-check-square"
  }) : _c('i', {
    staticClass: "fa fa-check-square-o"
  })]) : _vm._e(), _vm._v(" "), (_vm.canDelete) ? _c('button', {
    attrs: {
      "title": "Delete"
    },
    on: {
      "click": function($event) {
        _vm.startDelete()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })]) : _vm._e(), _vm._v(" "), (_vm.canEdit) ? _c('button', {
    attrs: {
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.startEdit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e(), _vm._v(" "), (_vm.canReply) ? _c('button', {
    attrs: {
      "title": "Reply"
    },
    on: {
      "click": function($event) {
        _vm.startReply()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  })]) : _vm._e(), _vm._v(" "), (_vm.canLike) ? _c('button', {
    class: {
      accent: _vm.isLiked
    },
    attrs: {
      "title": _vm.isLiked ? 'Unlike' : 'Like'
    },
    on: {
      "click": function($event) {
        _vm.toggleLike()
      }
    }
  }, [(_vm.isLiked) ? _c('i', {
    staticClass: "fa fa-thumbs-up"
  }) : _c('i', {
    staticClass: "fa fa-thumbs-o-up"
  })]) : _vm._e(), _vm._v(" "), (_vm.canShare) ? _c('span', {
    staticClass: "link-share-wrapper",
    attrs: {
      "title": "Share"
    }
  }, [_c('button', {
    class: {
      'accent-hover': _vm.linkShareShowing
    },
    on: {
      "click": function($event) {
        _vm.toggleLinkShare()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  })]), _vm._v(" "), _c('ForumShare', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.linkShareShowing),
      expression: "linkShareShowing"
    }],
    ref: "linkShare",
    attrs: {
      "value": _vm.postUrl
    },
    on: {
      "close": function($event) {
        _vm.closeLinkShare()
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing),
      expression: "isEditing"
    }]
  }, [_vm._t("saveEditorButton", [_c('button', {
    staticClass: "btn-primary",
    on: {
      "click": function($event) {
        _vm.saveEdit()
      }
    }
  }, [_vm._t("saveEditorLabel", [_vm._v("\n                            Save\n                        ")])], 2)]), _vm._v(" "), _vm._t("stopEditorButton", [_c('button', {
    on: {
      "click": function($event) {
        _vm.cancelEdit()
      }
    }
  }, [_vm._t("stopEditorLabel", [_vm._v("\n                            Cancel\n                        ")])], 2)])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDeleting),
      expression: "isDeleting"
    }]
  }, [_c('button', {
    staticClass: "btn-danger",
    on: {
      "click": function($event) {
        _vm.doDelete()
      }
    }
  }, [_vm._v("\n                    Delete\n                ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.cancelDelete()
      }
    }
  }, [_vm._v("\n                    Cancel\n                ")])])])]), _vm._v(" "), (_vm.lightbox.media.length > 0) ? _c('LightboxMediaGallery', {
    attrs: {
      "media": _vm.lightbox.media,
      "index": _vm.lightbox.index,
      "showing": _vm.lightbox.showing
    },
    on: {
      "update:index": function($event) {
        _vm.lightbox.index = $event
      },
      "update:showing": function($event) {
        _vm.lightbox.showing = $event
      }
    }
  }) : _vm._e()], 1) : (_vm.hasBeenDeleted(_vm.post)) ? _c('article', {
    staticClass: "forum-post forum-post-deleted"
  }, [_c('div', {
    staticClass: "post-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "post-date"
  }, [_c('span', {
    staticClass: "delete-status",
    attrs: {
      "title": _vm.deleteStatus(_vm.post)
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })]), _vm._v(" "), _c('span', {
    attrs: {
      "title": _vm.postStatus(_vm.post)
    }
  }, [_vm._v("\n                " + _vm._s(_vm.prettyPostDate(_vm.post)) + "\n            ")])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post-content"
  }, [_c('div', {
    staticClass: "post-content-html"
  }, [_c('em', [_vm._v("Post has been deleted.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27c51750!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/post.vue
// module id = 1977
// module chunks = 2